import {useContext} from "react";
import PermissionsContext from "../../utils/context";

// For routes that can only be accessed by authenticated users
function GuardWrapper({role, children,}) {
    const {permissions} = useContext(PermissionsContext)
    if (!permissions.includes(role)) {
        return <></>;
    }

    return <>{children}</>;
}

export default GuardWrapper;
